<div fxLayout="column">
  @if (!hasBidQuotes) {
    <div fxLayout="column" fxLayoutAlign="center center">
      <img alt="Illustration of a spreadsheet, a pen, and a calculator" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/accounts-spreadsheet-spot-hero.svg">
      <div class="forge-typography--heading2">No bids or quotes yet.</div>
    </div>
  }

  @for (bidQuote of bidQuotes; track bidQuote) {
    @if (!bidQuote.IsDeleted) {
      <bid-quote [canEdit]="canEdit" [model]="bidQuote" (onDelete)="onDelete($event)" (viewAttachments)="showAttachments($event)" (viewNotes)="showNotes($event)">
      </bid-quote>
    }
  }
</div>